/* eslint no-unsafe-optional-chaining: 1 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faTimes,
  faDownload,
  faPlayCircle,
  faFileAlt,
  faInfoCircle,
} from '@fortawesome/pro-light-svg-icons';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import moment from 'moment';
import forceDownload from './force-download';
import DetailsModal from './DetailsModal';
import AgentSentimentModal from './AgentSentimentModal';
import CallerSentimentModal from './CallerSentimentModal';
import ScriptModal from './row-adherence-modal';
import SentimentIcon from './SentimentIcon';

function CallTools({ record = {} }) {
  const dispatch = useDispatch();
  const [audioRow, setAudioRow] = useState({});
  const audioError = false;

  function toggleDetailsModal(id) {
    dispatch({ type: 'TOGGLE_RECORD_DETAIL', id });
  }

  function handleDownloadAudio() {
    forceDownload(record.recording_url, `${record.contact_id}.wav`);
  }

  function handleDownloadTranscript() {
    forceDownload(record.transcript_url, `${record.contact_id}.txt`);
  }

  function handleOpenDetailsModal() {
    toggleDetailsModal(record.contact_id);
  }

  if (record.contact_id === audioRow.contact_id) {
    return (
      <div className="d-flex justify-content-center">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <audio controls>
          <source src={record.recording_url} />
        </audio>
        <button
          type="button"
          className="btn ms-1"
          onClick={() => setAudioRow({})}
        >
          <FontAwesomeIcon icon={faCircleXmark} color="#d65656" size="xl" />
        </button>
      </div>
    );
  }
  return (
    <>
      <Button
        size="sm"
        color="link"
        title="Call details"
        onClick={() => handleOpenDetailsModal()}
        className="p-0 mx-1 btn-pop"
      >
        <FontAwesomeIcon
          fixedWidth
          icon={faInfoCircle}
          size="lg"
        />
      </Button>
      <Button
        size="sm"
        color="link"
        className="p-0 mx-1 btn-pop"
        title="Play call audio"
        disabled={audioError}
        onClick={() => setAudioRow(record)}
      >
        <FontAwesomeIcon
          fixedWidth
          icon={faPlayCircle}
          size="lg"
        />
      </Button>
      <Button
        size="sm"
        color="link"
        title="Download call audio"
        disabled={audioError}
        onClick={() => handleDownloadAudio()}
        className="p-0 mx-1 btn-pop"
      >
        <FontAwesomeIcon
          fixedWidth
          icon={faDownload}
          size="lg"
        />
      </Button>
      <Button
        size="sm"
        color="link"
        title="Download call transcript"
        disabled={!record.transcript_url}
        onClick={() => handleDownloadTranscript()}
        className="p-0 mx-1 btn-pop"
      >
        <FontAwesomeIcon
          fixedWidth
          icon={faFileAlt}
          size="lg"
        />
      </Button>
    </>
  );
}

function RecordRow({
  record = {},
  idx,
  style = {},
  className,
}) {
  const dispatch = useDispatch();
  const { records = {} } = useSelector(store => store);
  const {
    columnFilters,
    selectedAgents,
    initialSelect,
    callerSentimentModalId: callerSentimentModalOpen,
    agentSentimentModalId: agentSentimentModalOpen,
    detailModalId: detailsModalOpen,
    scriptModalId: scriptModalOpen,
    sortTerm,
  } = records;
  const agentSentiment = record.agent_sentiment || {};
  const callerSentiment = record.caller_sentiment || {};

  // function openEditInfo(username) {
  //   dispatch({ type: 'OPEN_EDIT_INFO', username })
  // };
  function addSelectedAgent(payload) {
    dispatch({ type: 'ADD_SELECTED_AGENT', payload });
  }
  function setInitialSelect(payload) {
    dispatch({ type: 'SET_INITIAL_SELECT', payload });
  }
  function toggleUserSidebar(payload) {
    dispatch({ type: 'TOGGLE_USER_SIDEBAR', payload });
  }
  function removeSelectedAgent(payload) {
    dispatch({ type: 'REMOVE_SELECTED_AGENT', payload });
  }
  function toggleAgentSentimentModal(id) {
    dispatch({ type: 'TOGGLE_RECORD_AGENT_SENTIMENT', id });
  }
  function toggleCallerSentimentModal(id) {
    dispatch({ type: 'TOGGLE_RECORD_CALLER_SENTIMENT', id });
  }
  // function toggleScriptModal(id) {
  //   dispatch({ type: 'TOGGLE_RECORD_SCRIPT', id });
  // }


  function handleUserSelect(e) {
    if (e.target.checked) {
      addSelectedAgent(record);
      setInitialSelect(false);

      if (initialSelect) {
        toggleUserSidebar(true);
      }
    } else {
      removeSelectedAgent(record);

      if (selectedAgents.length === 1) {
        setInitialSelect(true);
      }
    }
  }

  /* unused currently
  handleEditInfo = () => {
    const { openEditInfo, record } = this.props;
    openEditInfo(record.contact_id);
  };
  */

  function handleOpenAgentSentimentModal() {
    toggleAgentSentimentModal(record.contact_id);
  }

  function handleOpenCallerSentimentModal() {
    toggleCallerSentimentModal(record.contact_id);
  }

  /* unused currently
  handleOpenScriptModal = () => {
    const { record, toggleScriptModal } = this.props;
    toggleScriptModal(record.contact_id);
  };
  */


  const selected = Boolean(
    selectedAgents.find(
      (agent) => agent.contact_id === record.contact_id,
    ),
  );

  const scs = {}; // style for first call of an enrollment, if is sortTerm
  // const scs = { textDecoration: 'underline' };
  // const scs = {
  //   padding: '8px',
  //   marginLeft: '-8px',
  //   borderRadius: '8px',
  //   border: '2px solid black',
  //   backgroundColor: 'rgba(24, 105, 144, 0.2)',
  // };

  const cfs = columnFilters.reduce((res, v) => ({ ...res, [v.id]: v.value }), {});

  return (
    <tr
      className={className}
      style={{
        ...style,
      }}
    >
      {detailsModalOpen && (
        <DetailsModal record={record} />
      )}
      {agentSentimentModalOpen && (
        <AgentSentimentModal record={record} />
      )}
      {callerSentimentModalOpen && (
        <CallerSentimentModal record={record} />
      )}
      {scriptModalOpen && record.transcript_analysis && (
        <ScriptModal record={record} />
      )}

      <td className="text-center p-0 ps-1" style={{ opacity: '0' }}>
        <input
          className="form-control"
          id={`user-${record.contact_id}`}
          type="checkbox"
          onChange={(e) => handleUserSelect(e)}
          checked={selected}
        />
      </td>
      <td className="text-capitalize">
        <span style={idx === 0 && sortTerm === 'agent_name' ? scs : {}}>
          {record.agent_last_name}
        </span>
      </td>
      <td className="text-capitalize">
        <span style={idx === 0 && sortTerm === 'client_name' ? scs : {}}>
          {record.client_last_name}
        </span>
      </td>
      <td className="text-center w-100" style={{ borderRight: '1px solid black' }}>
        <CallTools record={record} />
      </td>
      <td
        className={`border-start ${!cfs['enrollment-status'] && 'd-none'}`}
        style={{ backgroundColor: '#E5F8FF' }}
      >
        <FontAwesomeIcon
          fixedWidth
          icon={record.enrollment_status ? faCheck : faTimes}
          className={record.enrollment_status ? 'text-success' : 'text-danger'}
          size="2x"
          title={record.enrollment_status ? 'Submitted' : 'Incomplete'}
        />
      </td>
      <td
        className={`${!cfs['enrollment-lastupdated'] && 'd-none'}`}
        style={{ backgroundColor: '#E5F8FF' }}
      >
        {`${moment(record.enrollment_date).format('M/D/YY')} at ${moment(record.enrollment_date).format('h:mma')}`}
      </td>
      <td
        className={`border-end ${!cfs['enrollment-id'] && 'd-none'}`}
        style={{ backgroundColor: '#E5F8FF' }}
      >
        {record.enrollment_id || '--'}
      </td>
      <td className={`${!cfs['callinfo-starttime'] && 'd-none'}`}>
        {`${moment(record.call_start).format('M/D/YY')} at ${moment(record.call_start).format('h:mma')}`}
      </td>
      <td className={`${!cfs['callinfo-duration'] && 'd-none'}`}>
        {moment.unix(record.call_duration).format('mm:ss')}
      </td>
      <td className={`text-capitalize ${!cfs['callinfo-type'] && 'd-none'}`}>
        {record.call_type}
      </td>
      <td className={`${!cfs['sentiment-agent'] && 'd-none'}`}>
        <Button
          color="link"
          className="btn-pop"
          onClick={() => handleOpenAgentSentimentModal()}
          disabled={!record.agent_sentiment}
        >
          <SentimentIcon sentiment={agentSentiment.Sentiment} size="lg" />
        </Button>
      </td>
      <td className={`${!cfs['sentiment-client'] && 'd-none'}`}>
        <Button
          color="link"
          className="btn-pop"
          onClick={() => handleOpenCallerSentimentModal()}
          disabled={!record.caller_sentiment}
        >
          <SentimentIcon sentiment={callerSentiment.Sentiment} size="lg" />
        </Button>
      </td>
      <td className={`${!cfs['scriptadherence-confidence'] && 'd-none'}`}>
        {
          record?.transcript_analysis?.combined_agent_transcript_confidence
            ? `${Number(100 * record?.transcript_analysis?.combined_agent_transcript_confidence).toFixed(0)}%`
            : 'N/A'
        }
      </td>
      <td className={`${!cfs['scriptadherence-overall'] && 'd-none'}`}>
        {
          (record?.transcript_analysis?.similarity_overall)
            ? `${Number(100 * record?.transcript_analysis?.similarity_overall).toFixed(0)}%`
            : 'N/A'
        }
      </td>
      <td className={`${!cfs['scriptadherence-acknowledge'] && 'd-none'}`}>
        {
          (record?.transcript_analysis?.sections?.acknowledge?.similarity)
            ? `${Number(100 * record?.transcript_analysis?.sections?.acknowledge?.similarity).toFixed(0)}%`
            : 'N/A'
        }
      </td>
      <td className={`${!cfs['scriptadherence-contact'] && 'd-none'}`}>
        {
          (record?.transcript_analysis?.sections?.contact?.similarity)
            ? `${Number(100 * record?.transcript_analysis?.sections?.contact?.similarity).toFixed(0)}%`
            : 'N/A'
        }
      </td>
      <td className={`${!cfs['scriptadherence-medicare'] && 'd-none'}`}>
        {
          (record?.transcript_analysis?.sections?.medicare?.similarity)
            ? `${Number(100 * record?.transcript_analysis?.sections?.medicare?.similarity).toFixed(0)}%`
            : 'N/A'
        }
      </td>
      <td className={`${!cfs['scriptadherence-eligibility'] && 'd-none'}`}>
        {
          (record?.transcript_analysis?.sections?.eligibility?.similarity)
            ? `${Number(100 * record?.transcript_analysis?.sections?.eligibility?.similarity).toFixed(0)}%`
            : 'N/A'
        }
      </td>
      <td className={`${!cfs['scriptadherence-payment'] && 'd-none'}`}>
        {
          (record?.transcript_analysis?.sections?.payment?.similarity)
            ? `${Number(100 * record?.transcript_analysis?.sections?.payment?.similarity).toFixed(0)}%`
            : 'N/A'
        }
      </td>
      <td className={`${!cfs['scriptadherence-attest'] && 'd-none'}`}>
        {
          (record?.transcript_analysis?.sections?.attest?.similarity)
            ? `${Number(100 * record?.transcript_analysis?.sections?.attest?.similarity).toFixed(0)}%`
            : 'N/A'
        }
      </td>
    </tr>
  );
}

export default RecordRow;
